/**
 * Constants for the per-workspace map configurator (WorkspaceMapConfigPage).
 *
 * Zoom bounds match the slider range the user can pick from; the runtime map's
 * own enforced bounds live in `MAP_CONFIG` (maplibre.ts) and are independent.
 */

import { POLAND_COUNTRY_CODE } from './country';

/** Persisted map-settings payload schema version. */
export const MAP_SETTINGS_VERSION = 1;

/** Lowest zoom value selectable on the configurator sliders. */
export const MAP_SETUP_ZOOM_MIN = 0;

/** Highest zoom value selectable on the configurator sliders. */
export const MAP_SETUP_ZOOM_MAX = 24;

/** Step between adjacent slider zoom values. */
export const MAP_SETUP_ZOOM_STEP = 0.5;

/** Default start zoom when a workspace has no saved configuration. */
export const MAP_SETUP_DEFAULT_START_ZOOM = 6;

/** Default minimum zoom when a workspace has no saved configuration. */
export const MAP_SETUP_DEFAULT_MIN_ZOOM = 4;

/** Default maximum zoom when a workspace has no saved configuration. */
export const MAP_SETUP_DEFAULT_MAX_ZOOM = 18;

/** ISO 3166-1 alpha-2 code preselected for Polish-language users by default. */
export const MAP_SETUP_DEFAULT_PL_COUNTRY_CODE = POLAND_COUNTRY_CODE;

/** Decimal places used when displaying latitude / longitude values. */
export const MAP_SETUP_COORDINATE_DECIMALS = 5;

/** Duration (ms) of the live-preview fly-to when the center changes. */
export const MAP_SETUP_FLY_TO_DURATION_MS = 1000;

/** Duration (ms) of the live-preview ease when a zoom slider changes. */
export const MAP_SETUP_ZOOM_EASE_MS = 300;

/** Decimal places used by the live-preview current-zoom indicator. */
export const MAP_SETUP_ZOOM_INDICATOR_DECIMALS = 1;
